import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppService } from 'app/app.service';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class FuseSearchLauncherService {
    constructor(
        private appService: AppService,
        private http: HttpClient,
    ) { }


    searchAnything(module: string, text: string) {
        return this.http.get(this.appService.getApiUrl() + 'service/search-anything/?module=' + module + '&text=' + text);
    }

    semanticSearch(query: string, limit: number = 10, from: number = 0) {
        return this.http.post(this.appService.getApiUrl() + 'applicant/semantic-search', {
            searchQuery: query,
            limit: limit,
            from: from
        });
    }

    recommendApplicants(projectId: string, limit: number = 10, from: number = 0) {
        return this.http.post(this.appService.getApiUrl() + 'applicant/recommend-applicants', {
            projectId: projectId,
            limit: limit,
            from: from
        });
    }
}
